/* eslint-disable import/no-anonymous-default-export */
import qs from 'querystring';
export default (api) => {

    const fetchAuctionList = (payload) => {
        return api.get(`v1/vehicles?${qs.stringify(payload)}`);
    };

    const fetchMyCars = (payload) => {
        return api.get(`v1/my/vehicles?${qs.stringify(payload)}`);
    };

    const fetchAuctionDetail = (auctionId) => {
        return api.get(`v1/vehicle/${auctionId}`);
    };

    const fetchSuggestedSearch = (searchStr) => {
        return api.get(`v1/auto-suggest?search=${searchStr}`);
    };

    return {
        fetchAuctionList,
        fetchAuctionDetail,
        fetchMyCars,
        fetchSuggestedSearch
    };
};
